import {useMemo} from "react";
import {Badge, MaterialIcon, typography} from "@variocube/cube-ui";
import {Lock, LockStatus} from "@variocube/app-api";
import {useLocalization} from "../../i18n";
import * as React from "react";

export function LockState({lock}: { lock?: Lock }) {
    const {t} = useLocalization();

    const lockUi = useMemo(() => {
        if (lock) {
            switch (lock.status) {
                case LockStatus.Open:
                    return {icon: MaterialIcon.lock_open, error: false, label: t("LockStatusOpen")};

                case LockStatus.Closed:
                    return {icon: MaterialIcon.lock, error: false, label: t("LockStatusClosed")};

                case LockStatus.Blocked:
                    return {
                        icon: MaterialIcon.error,
                        error: true,
                        label: t("LockStatusBlocked")
                    };

                case LockStatus.Breakin:
                    return {
                        icon: MaterialIcon.notifications,
                        error: true,
                        label: t("LockStatusBreakin")
                    };
            }
        }
    }, [lock]);

    if (!lockUi) {
        return (
            <div className={typography.colorError}>
                {t("LockNotFound")}
            </div>
        )
    }

    return (
        <Badge error={lockUi.error}>
            {lockUi.icon}
            <span>{lockUi.label}</span>
        </Badge>
    )
}